import { useState } from "react";

// Club/competition crest with graceful initials fallback (no broken images).
export const Crest = ({ src, alt = "", size = 28, className = "" }) => {
  const [err, setErr] = useState(false);
  const initials = (alt || "?")
    .split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  if (!src || err) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full bg-slate-900 text-white font-bold ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.4 }}
        aria-label={alt}
      >
        {initials || "?"}
      </span>
    );
  }
  return (
    <img
      src={src} alt={alt} width={size} height={size} onError={() => setErr(true)}
      loading="lazy" decoding="async"
      className={`object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
};
